<template>
  <div class="fanCollapse">
    <div class="between">
      <div class="cont flex_start" :class="{ conactiv: isunfold }">
        <div class="left flex_start">
          <span class="leftText tag">{{ leftText }}:</span>
          <span
            class="all tag"
            @click="condi(-1)"
            :class="{ tagactiv: -1 == status }"
            >不限</span
          >
        </div>

        <div class="right flex_start wrap" ref="solutag">
          <div
            v-for="(item, index) in tagify"
            :key="index"
            class="tag"
            :class="{ tagactiv: index == status }"
            @click="condi(index)"
          >
            {{ item.cat_name }}
          </div>
        </div>
      </div>
      <div class="svg" v-if="ishow" @click="isunfold = !isunfold">
        <svg-icon
          icon-class="jt_right "
          :class="{ flip90: isunfold }"
        ></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: {
      type: String,
      default: "您的问题",
    },
    tagify: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    status: -1,
    isunfold: false,
    domHei: 33,
  }),
  computed: {
    ishow() {
      return this.domHei > 33;
    },
  },
  mounted() {
    let that = this;
    this.$nextTick(() => {
      setTimeout(() => {
        that.domHei = this.$refs.solutag.clientHeight;
      }, 300);
    });
  },
  methods: {
    condi(index) {
      this.status = index;
      if (index == -1) {
        this.$emit("clitag");
      } else {
        this.$emit("clitag", this.tagify[index]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fanCollapse {
  font-size: 16px;

  .cont {
    align-items: flex-start;
    height: 33px;
    overflow: hidden;
    color: #666666;
    .tag {
      border-radius: 5px;
      padding: 1px 14px;
      margin-right: 24px;
      margin-bottom: 10px;
    }
    .left {
      .leftText {
        margin-right: 0px;
        color: #999999;
      }
      .all {
        margin-right: 10px;
        &:hover {
          cursor: pointer;
          background: #0465ea;
          color: #fff;
        }
      }
    }
    .right {
      width: 900px;
      div {
        &:hover {
          cursor: pointer;
          background: #0465ea;
          color: #fff;
        }
      }
    }
    .tagactiv {
      background: #0465ea;
      color: #fff;
    }
    &.conactiv {
      height: auto;
    }
  }
  .svg {
    flex: 1;
    align-self: self-start;
    text-align: center;
    position: relative;
    top: 5px;
    &:hover {
      color: #888;
    }
  }
}
</style>